import { AdminSettingsTabType } from "../business-components/adminSettings/AdminSettingsTabType";
import { CvpSettings } from "../settings/CvpSettings";
import { CvpLocale } from "./CvpLocale";

export enum PostMessageTypes {
  CVPEmbedReadyForSettings = "CVPEmbedReadyForSettings",
  CVPEmbedConfig = "CVPEmbedConfig",
  CVPRedirectHost = "CVPRedirectHost",
  CVPIframeAvailableContentHeight = "CVPIframeAvailableContentHeight",
  CVPFocusTextId = "CVPFocusTextId",
}

export interface PostMessageCVPFocusTextId {
  type: PostMessageTypes.CVPFocusTextId;
  textId: string;
}

export interface PostMessageCVPRedirectHost {
  type: PostMessageTypes.CVPRedirectHost;
  url: string;
  method: "push" | "replace";
  scrollToY?: number;
  hardRedirect: boolean;
}

export interface PostMessageCVPEmbedReadyForSettings {
  type: PostMessageTypes.CVPEmbedReadyForSettings;
  loadId: string;
  cvpIsLoggedIn: boolean;
}

export interface PostMessageCVPEmbedConfig {
  type: PostMessageTypes.CVPEmbedConfig;
  settingsComplete: CvpSettings;
  iframe_overrideLocale?: CvpLocale;
  iframe_preventNavigationTakeover?: boolean;
  sandbox?: boolean;
  adminSettingsTabType?: AdminSettingsTabType;
  hostUrl?: string;
  iframeAvailableContentHeight?: number;
}
